import { useMemo, useState } from 'react';
import { compareCode } from './utils/codeComparator.ts';

const DEFAULT_LEFT = `function greet(name) {
  return 'Merhaba ' + name;
}

console.log(greet('Dünya'));
`;

const DEFAULT_RIGHT = `function greet(name) {
  return \`Merhaba, \${name}!\`;
}

console.log(greet('Dünya'));
console.log('Bitti');
`;

function buildStats(rows) {
  const stats = { equal: 0, insert: 0, delete: 0, replace: 0 };
  for (const row of rows) stats[row.type]++;
  return stats;
}

export default function CodeComparator() {
  const [leftText, setLeftText] = useState(DEFAULT_LEFT);
  const [rightText, setRightText] = useState(DEFAULT_RIGHT);

  const [ignoreWhitespace, setIgnoreWhitespace] = useState(false);
  const [ignoreCase, setIgnoreCase] = useState(false);
  const [trimTrailingWhitespace, setTrimTrailingWhitespace] = useState(true);

  const rows = useMemo(
    () =>
      compareCode(leftText, rightText, {
        ignoreWhitespace,
        ignoreCase,
        trimTrailingWhitespace,
      }),
    [leftText, rightText, ignoreWhitespace, ignoreCase, trimTrailingWhitespace]
  );

  const stats = useMemo(() => buildStats(rows), [rows]);

  return (
    <div className="cc">
      <div className="cc-top">
        <div className="cc-title">
          <h1>Kod Karşılaştırıcı</h1>
          <p>İki metni satır bazında karşılaştırır.</p>
        </div>

        <div className="cc-options" role="group" aria-label="Karşılaştırma seçenekleri">
          <label className="cc-option">
            <input
              type="checkbox"
              checked={ignoreWhitespace}
              onChange={(e) => setIgnoreWhitespace(e.target.checked)}
            />
            Boşlukları yok say
          </label>
          <label className="cc-option">
            <input
              type="checkbox"
              checked={ignoreCase}
              onChange={(e) => setIgnoreCase(e.target.checked)}
            />
            Büyük/küçük harfi yok say
          </label>
          <label className="cc-option">
            <input
              type="checkbox"
              checked={trimTrailingWhitespace}
              onChange={(e) => setTrimTrailingWhitespace(e.target.checked)}
            />
            Satır sonu boşluklarını kırp
          </label>
        </div>
      </div>

      <div className="cc-editors">
        <div className="cc-editor">
          <div className="cc-editorTitle">Sol</div>
          <textarea
            className="cc-textarea"
            value={leftText}
            onChange={(e) => setLeftText(e.target.value)}
            spellCheck={false}
          />
        </div>
        <div className="cc-editor">
          <div className="cc-editorTitle">Sağ</div>
          <textarea
            className="cc-textarea"
            value={rightText}
            onChange={(e) => setRightText(e.target.value)}
            spellCheck={false}
          />
        </div>
      </div>

      <div className="cc-summary" aria-label="Diff özeti">
        <span className="cc-badge cc-badge--equal">Eşit: {stats.equal}</span>
        <span className="cc-badge cc-badge--insert">Ekleme: {stats.insert}</span>
        <span className="cc-badge cc-badge--delete">Silme: {stats.delete}</span>
        <span className="cc-badge cc-badge--replace">Değişim: {stats.replace}</span>
      </div>

      <div className="cc-diff">
        <div className="cc-diffTitle">Diff</div>

        {rows.length === 0 ? (
          <div className="cc-empty">Karşılaştırılacak satır yok.</div>
        ) : (
          <div className="cc-tableWrap">
            <table className="cc-table">
              <thead>
                <tr>
                  <th className="cc-th cc-th--ln">Sol</th>
                  <th className="cc-th">Kod</th>
                  <th className="cc-th cc-th--ln">Sağ</th>
                  <th className="cc-th">Kod</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i} className={`cc-row cc-row--${row.type}`}>
                    <td className="cc-ln">{row.leftLineNumber ?? ''}</td>
                    <td className="cc-code cc-code--left">
                      <pre className="cc-pre">{row.leftText}</pre>
                    </td>
                    <td className="cc-ln">{row.rightLineNumber ?? ''}</td>
                    <td className="cc-code cc-code--right">
                      <pre className="cc-pre">{row.rightText}</pre>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
